import React from 'react';
import { TableCell } from '@mui/material';
import { TSortableColumn } from '../../../Components/GenericTable/types';
import { TRecipient } from '../../types';

interface RecipientTableRowsProps {
  column: TSortableColumn;
  item: TRecipient;
  tableHovered: boolean;
  dispatch?: any;
}

const RecipientTableRows: React.FC<RecipientTableRowsProps> = ({
  column,
  item,
  tableHovered,
  dispatch
}) => {
  if (!column.enabled) return null;

  switch (column.id) {
    case 'id':
      return <TableCell key={`${item.id}-${column.id}`}>{item.id}</TableCell>;
    case 'name':
      return <TableCell key={`${item.id}-${column.id}`}>{item.name || '-'}</TableCell>;
    case 'emails':
      return <TableCell key={`${item.id}-${column.id}`}>{item.emails || '-'}</TableCell>;
    case 'status':
      return <TableCell key={`${item.id}-${column.id}`}>{item.status || '-'}</TableCell>;
    default:
      return <TableCell key={`${item.id}-${column.id}`} />;
  }
};

export default RecipientTableRows;
